import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { formatPrice } from '../../helper';

export const upsellInfo = (isUpsell, upsellStatus) => {
  if (!isUpsell) return 'Customer-created';
  return `Upsell: ${upsellStatus}`;
};

export const ExpandServices = (services, address = null) => {
  let serviceability_list = [];
  if (address && address.serviceability_note) {
    serviceability_list = address.serviceability_note.split('\n');
  }
  return (
    <span>
      <Table className="myTable" size="small">
        <TableHead>
          <TableRow selected>
            <TableCell />
            <TableCell>Service Name</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Service Duration (Hours)</TableCell>
            <TableCell>Labor Charge</TableCell>
            <TableCell>Parts Charge</TableCell>
            <TableCell>Service Type</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {services &&
            services
              .sort((s) => (s.status === 'DELETED' ? 1 : -1))
              .map((s) => (
                <TableRow
                  className={s.status === 'DELETED' ? 'deleted-service' : ''}
                  selected
                  key={s.id}
                >
                  <TableCell />
                  <TableCell>{s.display_name}</TableCell>
                  <TableCell>{s.status}</TableCell>
                  <TableCell>{s.labor_hours}</TableCell>
                  <TableCell>{formatPrice(s.labor_cost_dollars)}</TableCell>
                  <TableCell>{formatPrice(s.parts_cost_dollars)}</TableCell>
                  <TableCell>
                    {upsellInfo(s.is_upsell, s.upsell_status)}
                  </TableCell>
                </TableRow>
              ))}
        </TableBody>
      </Table>
      <span>
        {address &&
          serviceability_list.length > 0 &&
          serviceability_list.map((s) => <p>{s}</p>)}
      </span>
    </span>
  );
};

export const ExpandRecord = ({ record }) =>
  ExpandServices(record.services, record.customer_address);
